// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d7bda5418677fb0f0223","655":"c88a80861c06fcfb279e"}[chunkId] + ".js";
};